import React from 'react';
import PropTypes from 'prop-types';
import { registerField } from 'core/forms';
import classnames from 'classnames';

import isNaN from 'lodash/isNaN';

import { NumberInput } from 'uikit/inputs';

import styles from '../styles/formFieldNumber.module.scss';

const FormFieldNumber = ({
  className = '',
  fieldId,
  hasError = false,
  isDirty = false,
  schema = {
    isDisabled: false,
    isFullWidth: false,
    label: '',
    maxValue: null,
    minValue: null,
    prefixInputLabel: '',
    shouldHideInputLabel: false,
    shouldPreventScrollableChanges: false,
    step: null,
  },
  updateField,
  value = '',
}) => {
  const transformedValue = value === null || isNaN(value) ? '' : value;

  return (
    <NumberInput
      id={fieldId}
      className={classnames(styles.element, className, {
        [styles.hasError]: isDirty && hasError,
        [styles.isFullWidth]: schema.isFullWidth,
        [styles.shouldHideInputLabel]: schema.shouldHideInputLabel,
      })}
      value={transformedValue}
      onChange={(inputValue) => updateField(isNaN(inputValue) ? null : inputValue)}
      label={schema.prefixInputLabel || schema.label}
      minValue={schema.minValue}
      maxValue={schema.maxValue}
      isDisabled={schema.isDisabled}
      shouldPreventScrollableChanges={schema.shouldPreventScrollableChanges}
      step={schema.step}
    />
  );
};

FormFieldNumber.propTypes = {
  className: PropTypes.string,
  fieldId: PropTypes.string.isRequired,
  isDirty: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  schema: PropTypes.shape({
    label: PropTypes.string,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    isDisabled: PropTypes.bool,
    prefixInputLabel: PropTypes.string,
    shouldHideInputLabel: PropTypes.bool,
    shouldPreventScrollableChanges: PropTypes.bool,
    step: PropTypes.number,
  }),
  updateField: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
};

registerField('Number', React.memo(FormFieldNumber));

export default FormFieldNumber;
